import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { useContext as f } from "react";
import { a as x } from "../../../index-CROKJrb5.js";
import { c as p, f as u } from "../../../create-component-CBAeEoQ6.js";
import { a as d } from "../../../FormControlContext-C7A4R-3o.js";
import { FormControlHelperText as C } from "../FormControlHelperText/index.js";
import { FormControlRequired as j } from "../FormControlRequired/index.js";
import { renderFormControlLabel as F } from "../index.js";
const q = p(
  "FormControl",
  u(
    ({
      children: m,
      className: s,
      fieldClassName: e,
      fieldProps: i,
      helperText: o,
      label: n,
      required: l = !1,
      ...a
    }, c) => {
      const t = f(d);
      return /* @__PURE__ */ r.jsxs("div", { ref: c, className: s, ...a, children: [
        /* @__PURE__ */ r.jsx("label", { htmlFor: t.id, children: /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-items-baseline", children: [
          F(n),
          l && /* @__PURE__ */ r.jsx(j, {})
        ] }) }),
        /* @__PURE__ */ r.jsx(
          "div",
          {
            className: x(
              "cur-flex cur-w-full cur-transition-all",
              e
            ),
            ...i,
            children: m
          }
        ),
        typeof o == "string" ? /* @__PURE__ */ r.jsx(C, { context: t, children: o }) : o
      ] });
    }
  )
);
export {
  q as FormControlGroup
};
//# sourceMappingURL=index.js.map
